import { render, staticRenderFns } from "./VSelect.vue?vue&type=template&id=5f2e9e43&"
import script from "./VSelect.vue?vue&type=script&lang=ts&"
export * from "./VSelect.vue?vue&type=script&lang=ts&"
import style0 from "./VSelect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports